export default __webpack_public_path__ + "static/media/text.1dd36ce9.png";